import { iconSrcs } from '../../generated/manifests/tokenIcons';
import { ChainId, type Token } from '../../types';
import { bnb } from '../nativeTokens';

export const bscTestnet: Token[] = [
  bnb[ChainId.BSC_TESTNET],
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xB9e0E753630434d7863528cc73CB7AC638a7c8ff',
    decimals: 18,
    symbol: 'XVS',
    iconSrc: iconSrcs.xvs,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x5fFbE5302BadED40941A403228E6AD03f93752d9',
    decimals: 18,
    symbol: 'VAI',
    iconSrc: iconSrcs.vai,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x331F639B4F3CF6E391CD244e0b5027C5968Ec325',
    decimals: 18,
    symbol: 'VRT',
    iconSrc: iconSrcs.vrt,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x75107940Cf1121232C0559c747A986DEfbc69DA9',
    decimals: 18,
    symbol: 'SXP',
    iconSrc: iconSrcs.sxp,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x16227D60f7a0e586C66B005219dfc887D13C9531',
    decimals: 6,
    symbol: 'USDC',
    iconSrc: iconSrcs.usdc,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xA11c8D9DC9b66E209Ef60F0C8D969D3CD988782c',
    decimals: 6,
    symbol: 'USDT',
    iconSrc: iconSrcs.usdt,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x8301F2213c0eeD49a7E28Ae4c3e91722919B8B47',
    decimals: 18,
    symbol: 'BUSD',
    iconSrc: iconSrcs.busd,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xA808e341e8e723DC6BA0Bb5204Bafc2330d7B8e4',
    decimals: 18,
    symbol: 'BTCB',
    iconSrc: iconSrcs.btcb,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x98f7A83361F7Ac8765CcEBAB1425da6b341958a7',
    decimals: 18,
    symbol: 'ETH',
    iconSrc: iconSrcs.eth,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x969F147B6b8D81f86175de33206A4FD43dF17913',
    decimals: 18,
    symbol: 'LTC',
    iconSrc: iconSrcs.ltc,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x3022A32fdAdB4f02281E8Fab33e0A6811237aab0',
    decimals: 18,
    symbol: 'XRP',
    iconSrc: iconSrcs.xrp,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xcD34BC54106bd45A04Ed99EBcC2A6a3e70d7210F',
    decimals: 18,
    symbol: 'ADA',
    iconSrc: iconSrcs.ada,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x67D262CE2b8b846d9B94060BC04DC40a83F0e25B',
    decimals: 8,
    symbol: 'DOGE',
    iconSrc: iconSrcs.doge,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xcfeb0103d4BEfa041EA4c2dACce7B3E83E1aE7E3',
    decimals: 18,
    symbol: 'MATIC',
    iconSrc: iconSrcs.matic,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xe8bd7cCC165FAEb9b81569B05424771B9A20cbEF',
    decimals: 18,
    symbol: 'CAKE',
    iconSrc: iconSrcs.cake,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x4B7268FC7C727B88c5Fc127D41b491BfAe63e144',
    decimals: 18,
    symbol: 'AAVE',
    iconSrc: iconSrcs.aave,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xB32171ecD878607FFc4F8FC0bCcE6852BB3149E0',
    decimals: 18,
    symbol: 'TUSD',
    iconSrc: iconSrcs.tusd,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xFeC3A63401Eb9C1476200d7C32c4009Be0154169',
    decimals: 18,
    symbol: 'TUSDOLD',
    iconSrc: iconSrcs.tusd,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x7D21841DC10BA1C5797951EFc62fADBBDD06704B',
    decimals: 6,
    symbol: 'TRX',
    iconSrc: iconSrcs.trx,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x19E7215abF8B2716EE807c9f4b83Af0e7f92653F',
    decimals: 18,
    symbol: 'TRXOLD',
    iconSrc: iconSrcs.trx,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x6923189d91fdF62dBAe623a55273F1d20306D9f2',
    decimals: 18,
    symbol: 'ALPACA',
    iconSrc: iconSrcs.alpaca,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xe4a90EB942CF2DA7238e8F6cC9EF510c49FC8B4B',
    decimals: 18,
    symbol: 'ANKR',
    iconSrc: iconSrcs.ankr,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x5269b7558D3d5E113010Ef1cFF0901c367849CC9',
    decimals: 18,
    symbol: 'ankrBNB',
    iconSrc: iconSrcs.ankrBNB,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x5B662703775171c4212F2FBAdb7F92e64116c154',
    decimals: 18,
    symbol: 'BIFI',
    iconSrc: iconSrcs.bifi,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x327d6E6FAC0228070884e913263CFF9eFed4a2C8',
    decimals: 18,
    symbol: 'BNBx',
    iconSrc: iconSrcs.bnbx,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x7FCC76fc1F573d8Eb445c236Cc282246bC562bCE',
    decimals: 18,
    symbol: 'BSW',
    iconSrc: iconSrcs.bsw,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xE98344A7c691B200EF47c9b8829110087D832C64',
    decimals: 18,
    symbol: 'BTT',
    iconSrc: iconSrcs.btt,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xb22cF15FBc089d470f8e532aeAd2baB76bE87c88',
    decimals: 18,
    symbol: 'FLOKI',
    iconSrc: iconSrcs.floki,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xe73774DfCD551BF75650772dC2cC56a2B6323453',
    decimals: 18,
    symbol: 'lisUSD',
    iconSrc: iconSrcs.lisUSD,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xc440e4F21AFc2C3bDBA1Af7D0E338ED35d3e25bA',
    decimals: 18,
    symbol: 'NFT',
    iconSrc: iconSrcs.nft,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xD60cC803d888A3e743F21D0bdE4bF2cAfdEA1F26',
    decimals: 18,
    symbol: 'RACA',
    iconSrc: iconSrcs.raca,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x2999C176eBf66ecda3a646E70CeB5FF4d5fCFb8C',
    decimals: 18,
    symbol: 'stkBNB',
    iconSrc: iconSrcs.stkBNB,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x2E2466e22FcbE0732Be385ee2FBb9C59a1098382',
    decimals: 18,
    symbol: 'USDD',
    iconSrc: iconSrcs.usdd,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    decimals: 18,
    symbol: 'WBNB',
    iconSrc: iconSrcs.wbnb,
    tokenWrapped: bnb[ChainId.BSC_TESTNET],
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x2E6Af3f3F059F43D764060968658c9F3c8f9479D',
    decimals: 18,
    symbol: 'WIN',
    iconSrc: iconSrcs.win,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x65B849A4Fc306AF413E341D44dF8482F963fBB91',
    decimals: 18,
    symbol: 'WOO',
    iconSrc: iconSrcs.woo,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x9c37E59Ba22c4320547F00D4f1857AF1abd1Dd6f',
    decimals: 18,
    symbol: 'WBETH',
    iconSrc: iconSrcs.wbeth,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xac7D6B77EBD1DB8C5a9f0896e5eB5d485CB677b3',
    decimals: 18,
    symbol: 'SD',
    iconSrc: iconSrcs.sd,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xb99C6B26Fdf3678c6e2aff8466E3625a0e7182f8',
    decimals: 18,
    symbol: 'TWT',
    iconSrc: iconSrcs.twt,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x952653d23cB9bef19E442D2BF8fBc8843A968052',
    decimals: 18,
    symbol: 'THE',
    iconSrc: iconSrcs.the,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xd2aF6A916Bc77764dc63742BC30f71AF4cF423F4',
    decimals: 18,
    symbol: 'slisBNB',
    iconSrc: iconSrcs.slisBNB,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x63061de4A25f24279AAab80400040684F92Ee319',
    decimals: 18,
    symbol: 'EURA',
    iconSrc: iconSrcs.eura,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xD1Bc731d188ACc3f52a6226B328a89056B0Ec71a',
    decimals: 18,
    symbol: 'ANGLE',
    iconSrc: iconSrcs.angle,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x8D2f061C75780d8D91c10A7230B907411aCBC8fC',
    decimals: 18,
    symbol: 'UNI',
    iconSrc: iconSrcs.uni,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x52b4E1A2ba407813F829B4b3943A1e57768669A9',
    decimals: 18,
    symbol: 'PLANET',
    iconSrc: iconSrcs.planet,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xcF27439fA231af9931ee40c4f27Bb77B83826F3C',
    decimals: 18,
    symbol: 'FDUSD',
    iconSrc: iconSrcs.fdusd,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x4FA37fFA9f36Ec0e0e685C06a7bF169bb50409ce',
    decimals: 9,
    symbol: 'BabyDoge',
    iconSrc: iconSrcs.babyDoge,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x7df9372096c8ca2401f30B3dF931bEFF493f1FdC',
    decimals: 18,
    symbol: 'weETH',
    iconSrc: iconSrcs.weEth,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x4349016259FCd8eE452f696b2a7beeE31667D129',
    decimals: 18,
    symbol: 'wstETH',
    iconSrc: iconSrcs.wstEth,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x6855E14A6df91b8E4D55163d068E9ef2530fd4CE',
    decimals: 18,
    symbol: 'solvBTC',
    iconSrc: iconSrcs.solvBtc,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x964Ea3dC70Ee5b35Ea881cf8416B7a5F50E13f56',
    decimals: 18,
    symbol: 'PT-SolvBTC.BBN-MAR25',
    iconSrc: iconSrcs.ptSolvBtc,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xC337Dd0390FdFD0Ee5D2b682E425986EDD7b59da',
    decimals: 18,
    symbol: 'SOL',
    iconSrc: iconSrcs.sol,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x14AECeEc177085fd09EA07348B4E1F7Fcc030fA1',
    decimals: 18,
    symbol: 'PT-clisBNB-APR25',
    iconSrc: iconSrcs.ptClisBNB,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xc625f060ad25f4A6c2d9eBF30C133dB61B7AF072',
    decimals: 18,
    symbol: 'asBNB',
    iconSrc: iconSrcs.asBnb,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x95e58161BA2423c3034658d957F3f5b94DeAbf81',
    decimals: 18,
    symbol: 'PT-sUSDE-JUN2025',
    iconSrc: iconSrcs.ptSUsdE,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x986C30591f5aAb401ea3aa63aFA595608721B1B9',
    decimals: 18,
    symbol: 'USDe',
    iconSrc: iconSrcs.usde,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xcFec590e417Abb378cfEfE6296829E35fa25cEbd',
    decimals: 18,
    symbol: 'sUSDe',
    iconSrc: iconSrcs.sUsdE,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x7792af341a10ccc4B1CDd7B317F0460a37346a0A',
    decimals: 18,
    symbol: 'USD1',
    iconSrc: iconSrcs.usd1,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x3ea87323806586A0282b50377e0FEa76070F532B',
    decimals: 18,
    symbol: 'xSolvBTC',
    iconSrc: iconSrcs.xSolvBtc,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xC7a2b79432Fd3e3d5bd2d96A456c734AB93A0484',
    decimals: 18,
    symbol: 'USDF',
    iconSrc: iconSrcs.usdf,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x0c98334aCF440b9936D9cc1d99dc1A77bf26a93B',
    decimals: 18,
    symbol: 'PT-USDe-30OCT2025',
    iconSrc: iconSrcs.ptUsdE,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x180Bc1a9843A65D4116e44886FD3558515a56A49',
    decimals: 18,
    symbol: 'U',
    iconSrc: iconSrcs.u,
  },
  {
    chainId: ChainId.BSC_MAINNET,
    address: '0x60825e8eBbed5C32c1DAA7eA68ceCA70BEA65040',
    decimals: 18,
    symbol: 'PT-clisBNBx-25JUN2026',
    iconSrc: iconSrcs.slisBnbX,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xd2e2575c24302C82d38A9079c85722e0D0C0D2cD',
    decimals: 18,
    symbol: 'XAUm',
    iconSrc: iconSrcs.xaum,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x312e39c7641cE64BEccDe53613f07952258fa810',
    decimals: 6,
    symbol: 'MOCK_USDC',
    iconSrc: iconSrcs.usdc,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xCC3933141a64E26C9317b19CE4BbB4ec2c333bc6',
    decimals: 8,
    symbol: 'MOCK_WBTC',
    iconSrc: iconSrcs.wbtc,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x10d63B1203E5A0719AbbE927C8BFc87135b2F129',
    decimals: 18,
    symbol: 'TSLAB',
    iconSrc: iconSrcs.tslab,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x8A7d8589A597619A7842d3BC284b9a5a276FaE56',
    decimals: 18,
    symbol: 'NVDAB',
    iconSrc: iconSrcs.nvdab,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x6D9e91cB766259af42619c14c994E694E57e6E85',
    decimals: 18,
    symbol: 'SPCXB',
    iconSrc: iconSrcs.spcxb,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xb52DE23C6D4be6Bb3E87fF64527E856Ab346FDf2',
    decimals: 18,
    symbol: 'SKHYB',
    iconSrc: iconSrcs.skhyb,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0xCbfDC27d225Dd3F58DD19C3d37347d043458dcC8',
    decimals: 18,
    symbol: 'hBNB',
    iconSrc: iconSrcs.hBNB,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x7e4F548Dcd550f6F6a563AC9267d58f20cD135b4',
    decimals: 18,
    symbol: 'qhBNB',
    iconSrc: iconSrcs.defaultToken,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x7cE6ADF754D0eC81A6CF8ACd9C7454F45077dc61',
    decimals: 12,
    symbol: 'vSHARE',
    iconSrc: iconSrcs.vhUSDT,
  },
  {
    chainId: ChainId.BSC_TESTNET,
    address: '0x1fdD7eAFC771DA154B67Ca372FB80Ff78D7774D2',
    decimals: 24,
    symbol: 'vhTUSD',
    iconSrc: iconSrcs.vhUSDT,
  },
];
